import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../../revvComponents";

import NoteItem from "./NoteItem";
import { ConfirmationBox } from "../../commonComponents";

// Decalarations
const NOTE_TYPE = {
  private: "PRIVATE",
  public: "PUBLIC",
};

class NotesThread extends Component {
  state = {
    showAcceptConfirmationBox: false,
    showRejectConfirmationBox: false,
    noteType: NOTE_TYPE.public,
  };

  _handleStatusChange = status => {
    const { saveNote, noteThread, author } = this.props;
    if (!(author && author.id && author.id !== noteThread.author.id)) {
      noteThread.comment_status = status;
      saveNote(noteThread);
    }
  };

  _toggleNoteType = noteType => {
    this.setState({ noteType });
  };

  _getAcceptButton = () => {
    const { noteThread } = this.props;
    const { anchor } = noteThread;
    if (anchor.action === "DELETED" || anchor.action === "INSERTED") {
      return (
        <Button
          className="btn-accept btn-default"
          onClick={() => this.setState({ showAcceptConfirmationBox: true })}
          data-test="notesthread-accept-btn">
          <i>
            <FontAwesomeIcon icon={["far", "check"]} />
          </i>
          Accept
        </Button>
      );
    }
    return null;
  };

  _getRejectButton = () => {
    const { noteThread } = this.props;
    const { anchor } = noteThread;
    if (anchor.action === "DELETED" || anchor.action === "INSERTED") {
      return (
        <Button
          className="show-inline btn-reject btn-default"
          onClick={() => this.setState({ showRejectConfirmationBox: true })}
          data-test="notesthread-reject-btn">
          <i>
            <FontAwesomeIcon icon={["far", "times"]} />
          </i>
          Reject
        </Button>
      );
    }
    return null;
  };

  _getAcceptRejectFlag = () => {
    const { noteThread, author } = this.props;
    const {
      anchor,
      comment_status: commentStatus,
      author: noteAuthor,
    } = noteThread;
    if (anchor.action === "DELETED" || anchor.action === "INSERTED") {
      if (
        commentStatus.toLowerCase() === "open" &&
        author &&
        author.id &&
        author.id === noteAuthor.id
      ) {
        return (
          <div className="note-footer">
            {this._getAcceptButton()}
            {this._getRejectButton()}
          </div>
        );
      }
      return (
        <div className="note-footer">
          <Button
            className="btn btn-info btn-resolve btn-resolved"
            data-test="notesthread-commentstatus-btn">
            <FontAwesomeIcon
              icon={["far", "check"]}
              className="btn-resolve-icon"
            />
            {commentStatus}
          </Button>
        </div>
      );
    }
    return null;
  };

  _getResolveFlag = () => {
    const { noteThread, author } = this.props;
    const {
      base_comment_id: baseCommentId,
      comment_status: commentStatus,
      author: noteAuthor,
    } = noteThread;

    if (baseCommentId !== null) {
      return null;
    }
    if (author && author.id && author.id !== noteAuthor.id) {
      if (commentStatus === "RESOLVED") {
        return (
          <Button
            className="btn-resolve btn-resolved"
            data-test="notesthread-resolved-btn">
            <FontAwesomeIcon
              icon={["far", "check"]}
              className="btn-resolve-icon"
            />
            Resolved
          </Button>
        );
      }
      return null;
    }
    let resolveBtn = null;
    if (commentStatus === "OPEN") {
      resolveBtn = (
        <Button
          data-test="notesthread-resolve-button"
          className="btn-resolve"
          onClick={() => this._handleStatusChange("RESOLVED")}>
          <FontAwesomeIcon
            icon={["far", "check"]}
            className="btn-resolve-icon"
          />
          Resolve
        </Button>
      );
    } else if (commentStatus === "RESOLVED") {
      resolveBtn = (
        <Button
          data-test="notesthread-resolved-button"
          className="btn btn-info btn-resolve btn-resolved"
          onClick={() => this._handleStatusChange("OPEN")}>
          <FontAwesomeIcon
            icon={["far", "check"]}
            className="btn-resolve-icon"
          />
          Resolved
        </Button>
      );
    }
    return resolveBtn;
  };

  _getReplyButton = () => {
    const { noteThread, addReply } = this.props;
    if (noteThread.comment_status !== "RESOLVED") {
      return (
        <Button
          data-test="notesthread-reply-button"
          className="show-inline note-reply-btn"
          onClick={() => addReply(noteThread.id)}>
          <FontAwesomeIcon icon={["far", "reply"]} className="btn-reply-icon" />
          Reply
        </Button>
      );
    }
    return null;
  };

  _getNoteThreadView = () => {
    const { noteThread } = this.props;
    const { replies } = noteThread;
    // const { replies, is_public: isPublic } = noteThread;
    if (replies === null || replies === undefined) {
      return null;
    }
    return replies.map(note => (
      <NoteItem
        note={note}
        key={note.id}
        {...this.props}
        noteType={this.state.noteType}
        toggleNoteType={this._toggleNoteType}
      />
    ));
  };

  _getNoteFooter = () => {
    // if the current note thread is in active mode, or any of its reply is in active mode,
    // or if the note thrtead is new and unsaved or any reply is new and saved,
    // it should allow to reply or resolve to the thread
    const { noteThread, activeNoteID, isSharedDocument } = this.props;
    const { anchor } = noteThread;
    // check if there is any reply, without id, i.e. new and unsaved reply
    const newreply = Array.isArray(noteThread.replies)
      ? noteThread.replies.reduce((open, reply) => open && reply.id, 1)
      : true;
    // check if there is any reply in active state
    const activeReply = Array.isArray(noteThread.replies)
      ? noteThread.replies.reduce(
          (active, reply) => active && reply.id !== activeNoteID,
          1,
        )
      : true;

    if (
      !isSharedDocument &&
      ((anchor && anchor.action === "DELETED") || anchor.action === "INSERTED")
    ) {
      return this._getAcceptRejectFlag();
    }
    if (
      noteThread &&
      newreply &&
      noteThread.id !== activeNoteID &&
      activeReply
    ) {
      return (
        <div className="note-footer">
          {!isSharedDocument && this._getResolveFlag()}
          {this._getReplyButton()}
        </div>
      );
    }
    return null;
  };

  render() {
    const { noteThread, acceptRejectChanges, isSharedDocument } = this.props;
    const { is_public: isPublicNote } = noteThread;
    const { showAcceptConfirmationBox, showRejectConfirmationBox, noteType } =
      this.state;
    const acceptConfirmationPopupSpace = showAcceptConfirmationBox ? (
      <ConfirmationBox
        show={showAcceptConfirmationBox}
        closePopup={() => this.setState({ showAcceptConfirmationBox: false })}
        header="Are you sure you want to accept this change ?"
        subHeader={`Once accepted, you won't be able to undo this.`}
        checkboxLabel="Yes, I want to accept."
        confirmAction={() => acceptRejectChanges(noteThread, true)}
        okBtnText="Accept"
      />
    ) : null;
    const rejectConfirmationPopupSpace = showRejectConfirmationBox ? (
      <ConfirmationBox
        show={showRejectConfirmationBox}
        closePopup={() => this.setState({ showRejectConfirmationBox: false })}
        header="Are you sure you want to reject this change ?"
        subHeader={`Once rejected, you won't be able to undo this.`}
        checkboxLabel="Yes, I want to reject."
        confirmAction={() => acceptRejectChanges(noteThread, false)}
        okBtnText="Reject"
      />
    ) : null;
    let isPrivateNote = noteType === NOTE_TYPE.private;
    if (!isPublicNote && isPublicNote !== undefined) {
      isPrivateNote = true;
    }

    return (
      <div
        className={`note-thread ${isPrivateNote ? "private-thread" : ""}`}
        data-test="notesthread-new-note-border"
        id={`${
          noteThread.id === null
            ? "new-note-with-null-id"
            : `note-thread-${noteThread.id}`
        }`}>
        <NoteItem
          note={noteThread}
          {...this.props}
          noteType={noteType}
          toggleNoteType={this._toggleNoteType}
          isSharedDocument={isSharedDocument}
        />
        {acceptConfirmationPopupSpace}
        {rejectConfirmationPopupSpace}
        {this._getNoteThreadView()}
        {this._getNoteFooter()}
      </div>
    );
  }
}

export default NotesThread;
